import { type NexusApiActionDef } from "./action-def.types";
import { deleteOutput, listOutput, num, obj, str } from "./output-format.builders";

export const collectionActions: NexusApiActionDef[] = [
  {
    action: "collections.list",
    label: "List Collections",
    description: "List knowledge collections",
    inputSchema: {
      search: { type: "string", description: "Search filter (optional)" },
      limit: { type: "number", description: "Max results (optional)" }
    },
    outputFormat: listOutput("collections")
  },
  {
    action: "collections.get",
    label: "Get Collection",
    description: "Get collection details",
    inputSchema: {
      collectionId: { type: "string", description: "Collection ID" }
    },
    outputFormat: obj("Collection details")
  },
  {
    action: "collections.create",
    label: "Create Collection",
    description: "Create a new knowledge collection",
    inputSchema: {
      name: { type: "string", description: "Collection name" },
      displayName: { type: "string", description: "Display name (optional)" },
      description: { type: "string", description: "Description (optional)" },
      documentIds: { type: "string", description: "Document IDs (comma-separated, optional)" }
    },
    outputFormat: obj("Created collection")
  },
  {
    action: "collections.update",
    label: "Update Collection",
    description: "Update collection settings",
    inputSchema: {
      collectionId: { type: "string", description: "Collection ID" },
      displayName: { type: "string", description: "Display name (optional)" },
      description: { type: "string", description: "Description (optional)" }
    },
    outputFormat: obj("Updated collection")
  },
  {
    action: "collections.delete",
    label: "Delete Collection",
    description: "Delete a collection",
    inputSchema: {
      collectionId: { type: "string", description: "Collection ID" }
    },
    outputFormat: deleteOutput
  },
  {
    action: "collections.search",
    label: "Search Collection",
    description: "Search within a knowledge collection",
    inputSchema: {
      collectionId: { type: "string", description: "Collection ID" },
      query: { type: "string", description: "Search query" },
      limit: { type: "number", description: "Max results (optional)" },
      includeMetadata: { type: "boolean", description: "Include metadata (optional)" }
    },
    outputFormat: obj("Search results")
  },
  {
    action: "collections.searchMultiple",
    label: "Search Multiple Collections",
    description: "Search across multiple collections",
    inputSchema: {
      collectionIds: { type: "string", description: "Collection IDs (comma-separated)" },
      query: { type: "string", description: "Search query" },
      limit: { type: "number", description: "Max results per collection (optional)" }
    },
    outputFormat: obj("Multi-collection search results")
  },
  {
    action: "collections.attachDocuments",
    label: "Attach Documents",
    description: "Attach documents to a collection",
    inputSchema: {
      collectionId: { type: "string", description: "Collection ID" },
      documentIds: { type: "string", description: "Document IDs (comma-separated)" }
    },
    outputFormat: obj("Attachment result")
  },
  {
    action: "collections.listDocuments",
    label: "List Collection Documents",
    description: "List documents in a collection",
    inputSchema: {
      collectionId: { type: "string", description: "Collection ID" }
    },
    outputFormat: listOutput("documents")
  },
  {
    action: "collections.removeDocument",
    label: "Remove Document from Collection",
    description: "Remove a document from a collection",
    inputSchema: {
      collectionId: { type: "string", description: "Collection ID" },
      documentId: { type: "string", description: "Document ID" }
    },
    outputFormat: obj("Removal result")
  },
  {
    action: "collections.getStatistics",
    label: "Get Collection Statistics",
    description: "Get statistics for a collection",
    inputSchema: {
      collectionId: { type: "string", description: "Collection ID" }
    },
    outputFormat: obj("Statistics", {
      id: str("Collection ID"),
      name: str("Collection name"),
      documentCount: num("Number of documents")
    })
  }
];
